import DOMPurify from "isomorphic-dompurify";

const STRIP_OPTIONS = { ALLOWED_TAGS: [] as string[], KEEP_CONTENT: true };

export function stripHtmlTags(html: string): string {
  return DOMPurify.sanitize(html, STRIP_OPTIONS).trim();
}

export function stripHtml(html: string): string {
  return DOMPurify.sanitize(html, STRIP_OPTIONS)
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
}
